import StockSubsectionPlaceholder from "../../../components/StockSubsectionPlaceholder";

export default function EvolucionPage() {
  return (
    <StockSubsectionPlaceholder
      sectionPath="dashboard"
      subsectionPath="evolucion"
    />
  );
}
